import React from 'react'
import PropTypes from 'prop-types'
import SitePicker from 'components/SitePicker'
import { ErrorBoundary, Loading } from 'secondstep-components'
import { domains } from '../../config/env'
import { REDIRECT_TO_DASHBOARD, TRAINING_DESCRIPTION, TITLE } from './constants'

import {
  Description,
  TextLinkContainer,
  StyledTextLink,
  StyledTextLinkDashboard,
  Title,
  SitePickerContainer,
  UserCount,
  TableContainer,
  LoadingWrapper,
} from './component.styles'
import SiteUserTrainingGrid from 'components/SiteUserTrainingGrid'

const TrainingReport = ({
  className,
  isLoading,
  site,
  sites,
  siteUsers,
  onSiteChange,
  pendingUsersCount,
  redirectToUserManagement,
}) => {
  if (isLoading) {
    return (
      <LoadingWrapper>
        <Loading dataTestId="loading-logo" />
      </LoadingWrapper>
    )
  }

  return (
    <ErrorBoundary>
      <TextLinkContainer>
        <StyledTextLinkDashboard
          dataTestId="textlink-back-to-dashboard"
          href={`${domains.LEARN_APP_DOMAIN}`}
        >
          {REDIRECT_TO_DASHBOARD}
        </StyledTextLinkDashboard>
      </TextLinkContainer>
      <SitePickerContainer>
        <SitePicker
          onSiteChange={onSiteChange}
          selectedSite={site}
          sites={sites}
        />
      </SitePickerContainer>
      <Title>{TITLE}</Title>
      <Description>{TRAINING_DESCRIPTION}</Description>
      {pendingUsersCount > 0 && (
        <UserCount>
          {pendingUsersCount} Pending Users -{' '}
          <StyledTextLink onClick={redirectToUserManagement}>
            User Management
          </StyledTextLink>
        </UserCount>
      )}
      <TableContainer>
        {siteUsers && (
          <SiteUserTrainingGrid
            className={className}
            site={site}
            users={siteUsers}
          />
        )}
      </TableContainer>
    </ErrorBoundary>
  )
}

TrainingReport.propTypes = {
  className: PropTypes.string,
  data: PropTypes.array,
  error: PropTypes.object,
  isLoading: PropTypes.bool,
  site: PropTypes.object,
  siteId: PropTypes.number,
}

TrainingReport.defaultProps = {
  isLoading: false,
  data: [],
  error: null,
}

export default TrainingReport
